import { SearchIcon } from "@heroicons/react/solid"
import { HttpError, useOne } from "@refinedev/core";
import Button from "components/button"
import Input from "components/input"
import Select from "components/select";
import { useState } from "react";
import { PICKUP_ACCOUNT_TYPES, STATUS_OPTIONS } from "utills/constants";

export const Filter = ({ currentFilterValues, setFilters}: {currentFilterValues: any, setFilters: any}) => {

  const { data, isLoading } = useOne< {id: string, name: string}[], HttpError>({
    resource: "pickup/events/dropdown",
    id: "",
    meta: {
      resource: "data"
    }
  });

  const eventIds = (data?.data ?? []).map((event: {id: string, name: string}) => (
    { value: event.id, label: event.name }
  ));

  const _handleSubmitFilter = () => {
    setFilters([
      {field: "q", operator: "contains", value: keyword},
      {field: "event_id", operator: "eq", value: eventId},
      {field: "account_type", operator: "eq", value: accountType},
      {field: "is_active", operator: "eq", value: isActive},
      {field: "page", operator: "eq", value: 1}
    ])
  }

  const [keyword, setKeyword] = useState(currentFilterValues.q);
  const [eventId, setEventId] = useState(currentFilterValues.event_id);
  const [accountType, setAccountType] = useState(currentFilterValues.account_type)
  const [isActive, setIsActive] = useState(currentFilterValues.is_active);
  return (
    <div className="w-full flex flex-col gap-y-4 md:flex-row md:items-end md:gap-x-3">
      <div className="flex-1">
        <label htmlFor="name" className="block text-sm font-medium leading-6">
          Search
        </label>
        <div className="mt-2">
          <Input 
            className="px-2 py-2"
            label='Search'
            id='name'
            type="text"
            placeholder="Search by User name, Account name"
            value={keyword}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setKeyword(e.target.value)}
            onKeyDown={(e: React.KeyboardEvent) => {
              if (e.key === 'Enter') {
                _handleSubmitFilter();
              }
            }}
          />
        </div>
      </div>
      <div className="flex-1">
        <label htmlFor="account_type" className="block text-sm font-medium leading-6">
          Role name
        </label>
        <div className="mt-2">
          <Select
            options={PICKUP_ACCOUNT_TYPES}
            isLoading={isLoading}
            id="account_type"
            placeholder="Select Role Name"
            className="py-0.5"
            value={PICKUP_ACCOUNT_TYPES.find((d) => d.value === accountType)}
            onChange={(selected: {label: string; value: string}) => setAccountType(selected?.value)}
          />
        </div>
      </div>
      <div className="flex-1">
        <label htmlFor="event_id" className="block text-sm font-medium leading-6">
          Event Name
        </label>
        <div className="mt-2">
          <Select
            options={eventIds}
            isLoading={isLoading}
            isClearable={true}
            id="event_id"
            placeholder="Select Event"
            className="py-0.5"
            value={eventIds.find((d) => d.value === eventId)}
            onChange={(selected: {label: string; value: string}) => setEventId(selected?.value)}
          />
        </div>
      </div>
      <div className="flex-1">
        <label htmlFor="is_active" className="block text-sm font-medium leading-6">
          Status
        </label>
        <div className="mt-2">
          <Select
            options={STATUS_OPTIONS}
            isClearable={true}
            id="is_active"
            placeholder="Select Status"
            className="py-0.5"
            value={STATUS_OPTIONS.find((d) => d.value === isActive)}
            onChange={(selected: {label: string; value: string}) => setIsActive(selected?.value)}
          />
        </div>
      </div>
      <div className="shrink-0">
        <label htmlFor="status" className="block text-sm font-medium leading-6">
          <span className="sr-only">Search</span>
        </label>
        <div className="mt-2 w-full">
          <Button type="submit" className="w-full bg-white rounded-md px-3 text-brand-500 py-2 border-solid border-brand-500 border-[1px] hover:bg-white active:bg-white active:opacity-85" onClick={_handleSubmitFilter}>
            <SearchIcon className="w-3 h-4 text-brand-500 mr-2" /> Search
          </Button>
        </div>
      </div>
    </div>
  )
}